import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
const KEY = ['student-invitations'];
export function useStudentInvitations() {
    return useQuery({
        queryKey: KEY,
        queryFn: () => apiClient('/students/invitations'),
        staleTime: 1000 * 30,
    });
}
export function useCreateStudentInvitation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/students/invitations', {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: KEY });
            void queryClient.invalidateQueries({ queryKey: ['prospects'] });
        },
    });
}
export function useBulkCreateStudentInvitations() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/students/invitations/bulk', {
            method: 'POST',
            body: JSON.stringify(dto),
        }),
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: KEY });
            void queryClient.invalidateQueries({ queryKey: ['prospects'] });
        },
    });
}
export function useResendStudentInvitation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/students/invitations/${id}/resend`, {
            method: 'POST',
        }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: KEY }),
    });
}
export function useCancelStudentInvitation() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/students/invitations/${id}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: KEY }),
    });
}
//# sourceMappingURL=useStudentInvitations.js.map